import { Component, OnInit, ViewChild } from '@angular/core';
import { SchedulingService } from '../../modules/scheduling/scheduling.service';
import { OperatoryDataModel } from '../../models/clients/operatory-data.model';
import { SchedulingComponent } from '../../modules/scheduling/scheduling.component';

import { TdoMiniCalendarComponent } from '../../tdo-controls/common/tdo-mini-calendar/tdo-mini-calendar.component';
import { ClientLocationDataModel } from '../../models/clients/client-location-data.model';
import { LocationsSelectionModel } from './models/locations-selection.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DoctorDataModel } from '../../models/doctors/doctor-data.model';
import { DoctorQueryOptionsModel } from '../../models/doctors/doctor-query-options.model';
import { DoctorsService } from '../../services/doctors.service';
import { TdoDropdownChange } from '../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { DayDetailViewComponent } from './day-detail-view/day-detail-view.component';
import { Globals } from '../../globals';
import { DialogService } from '../../services/dialog.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { WaitListDialogComponent } from '../../modules/scheduling/wait-list-dialog/wait-list-dialog.component';
import { AppointmentDialogDataModel } from '../../modules/scheduling/models/appointment-dialog-data.model';
import { StaticDataService } from 'src/app/services/static-data.service';


@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {
  @ViewChild('scheduling') scheduling: SchedulingComponent;
  @ViewChild('calendar') calendar: TdoMiniCalendarComponent;
  @ViewChild('detailView') detailView: DayDetailViewComponent;
  viewType: string = 'day';

  selectedLocationsOperatoryData: OperatoryDataModel[];
  selectedDate: Date;

  selectedLocations: ClientLocationDataModel[] = [];
  currentLocation: ClientLocationDataModel;
  currentLocationOperatoryData: OperatoryDataModel[] = [];
  providerDocs: DoctorDataModel[];
  selectedDocs: DoctorDataModel[] = [];
  isReferralAppointment: boolean = false;
  showWaitList: boolean = false;
  isReschedule: boolean = false;
  rescheduleTooltipText: string = '';
  appointmentDialogData: AppointmentDialogDataModel = new AppointmentDialogDataModel();

  selectedType: string = '';

  doctorPredicate: (data: DoctorDataModel) => string;

  constructor(private schedulingService: SchedulingService,
    private doctorsService: DoctorsService,
    private router: Router,
    public globals: Globals,
    private activeRoute: ActivatedRoute,
    private dialogService: DialogService,
    private staticDataService: StaticDataService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.globals.ReferralAppointmentRequest) {
      this.isReferralAppointment = true;
    }
    if (this.globals.RescheduleAppointmentRequest) {
      this.isReschedule = true;
    }

    //validate Wait List
    this.getWaitList();

    //
    this.activeRoute.queryParams.subscribe((res) => {
      if (res && res.viewType) {
        this.viewType = res.viewType;
      }
    });

    if (this.staticDataService.currentLocationDoctors) {
      this.providerDocs = this.staticDataService.currentLocationDoctors;
    }
    else {
      const doctorQueryModel = new DoctorQueryOptionsModel();
      doctorQueryModel.isLazyLoad = false;
      doctorQueryModel.isIncludeTdo = true;
      doctorQueryModel.isIncludeReferring = false;
      this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {
        this.providerDocs = allDoctors;
      });
    }
    this.doctorPredicate = (data: DoctorDataModel) => {
      if (data?.dataContact) {
        return 'Dr. ' + data?.dataContact?.LastName;
      } else {
        return 'All';
      }
    };
  }

  getReferralTooltipText(): string {
    if (this.globals.ReferralAppointmentRequest) {
      const { ReferralDoctorFullName, PatientFullName, ProviderFullName } = this.globals.ReferralAppointmentRequest;
      const tooltipText = `Referral Doctor: ${ReferralDoctorFullName} \n Patient: ${PatientFullName} \n Provider Doctor: ${ProviderFullName}`;
      return tooltipText.trim(); // Trim leading and trailing spaces
    }
    else {
      this.isReferralAppointment = false;
      return '';
    }
  }

  getRescheduleTooltipText(): string {
    if (this.globals.RescheduleAppointmentRequest) {
      const { Patient_FullName, Reschedule_Note } = this.globals.RescheduleAppointmentRequest;
      const tooltipText = `Reschedule: Please select time \n Patient: ${Patient_FullName} \n Notes: ${Reschedule_Note}`;
      return tooltipText.trim(); // Trim leading and trailing spaces
    }
    else {
      this.isReschedule = false;
      return '';
    }
  }



  onRowContextMenu(event: MouseEvent) {
    event.stopImmediatePropagation();
    this.dialogService.openConfirmDialog('Clear Referrals ?').subscribe((result) => {
      if (result === true) {
        this.globals.ReferralAppointmentRequest = null;
        this.isReferralAppointment = false;
      } else {
      }
    });
  }

  onSelectedDateChange(date: Date) {
    this.selectedDate = date;
  }

  onViewTypeChange(type: string): void {
    this.viewType = type;
    this.router.navigate(
      ['/scheduler'],
      { queryParams: { viewType: this.viewType } }
    );
  }

  onOperatoriesSelected(operatories: OperatoryDataModel[]) {
    this.selectedLocationsOperatoryData = operatories;
    // this.selectedLocationsOperatoryData = this.sele.filter(p => this.selectedOperatoryIds.includes(p.OperatoryId));
    this.filterOperatoryData(operatories);
  }

  filterOperatoryData(operatories: OperatoryDataModel[]) {

    this.currentLocationOperatoryData = this.selectedLocationsOperatoryData.filter(p => p.LOCID === this.currentLocation.LOCID);

    if (this.scheduling) {
      this.calendar.updateLocation(this.currentLocation?.LOCID.toString());
      this.scheduling.setNewLocations([this.currentLocation]);
    } else {
      const ivl = setInterval(() => {
        if (this.scheduling) {
          clearInterval(ivl);
          this.calendar.updateLocation(this.currentLocation?.LOCID.toString());
          this.scheduling.setNewLocations([this.currentLocation]);
        }
      }, 100);
    }
  }

  // When one or many locations selected from dropdown
  onLocationsSelected(event: ClientLocationDataModel[]) {
    //const locids = event.map(p => p.LOCID);
    /*this.schedulingService.getOperatoriesV2(locids).subscribe((res) => {
      this.allOperatoryData = res;
    });*/

    //this.scheduling.setNewLocations(event);
    //this.selectedLocations = event;
    // this.onLocationTabSelected(event[0]);

    // TODO Which should this use if multiple selected?
    //this.calendar.updateLocation(event[0].LOCID.toString());
  }

  onLocationsOrOpsChanged(event: LocationsSelectionModel) {
    this.selectedLocations = event.locations;
    this.selectedLocationsOperatoryData = event.operatories;
    //if (event.locations.length>0)
    this.onLocationTabSelected(event.locations[0]);
  }

  getWaitList() {
    this.schedulingService.getWaitList().subscribe(result => {
      result === true ? this.showWaitList = true : this.showWaitList = false;
    });
  }

  onLocationTabSelected(loc: ClientLocationDataModel) {

    this.currentLocation = loc;
    this.currentLocationOperatoryData = this.selectedLocationsOperatoryData.filter(p => p.LOCID === loc?.LOCID);

    if (this.scheduling) {
      this.calendar.updateLocation(this.currentLocation?.LOCID.toString());
      this.scheduling.setNewLocations([this.currentLocation]);
    } else {
      const ivl = setInterval(() => {
        if (this.scheduling) {
          clearInterval(ivl);
          this.calendar.updateLocation(this.currentLocation?.LOCID.toString());
          this.scheduling.setNewLocations([this.currentLocation]);
        }
      }, 100);
    }
  }


  isSelectedLocationTab(loc: ClientLocationDataModel) {
    return loc === this.currentLocation;
  }

  onDocListClosed(event: TdoDropdownChange) {
    this.selectedDocs = event.value;
    if (this.detailView) {
      this.detailView.updateDoctors(this.selectedDocs);
    }

  }

  onDocListChanged(event: TdoDropdownChange) {
    console.log(' onDocListChanged test');
  }

  receiveObject(object: AppointmentDialogDataModel) {
    this.appointmentDialogData = object;
  }

  onOpenWaitListComponent() {
    const config = new MatDialogConfig();
    config.width = '800px';
    config.height = '500px';
    config.panelClass = 'dialog';
    config.data = this.appointmentDialogData;
    const dialogRef = this.dialog.open(WaitListDialogComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReschedule = true;
      }
    }, err => {
      console.log(err);
    });

  }

  /*isItemSelected(type: string): boolean {
    return type === this.selectedType;
  }*/
}
